import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { HeadingType } from '@freelancer/ui/heading';
import { InputSize } from '@freelancer/ui/input';
import { Margin } from '@freelancer/ui/margin';
import { SpinnerSize } from '@freelancer/ui/spinner';
import { TextSize } from '@freelancer/ui/text';
import * as Rx from 'rxjs';
import { JobType } from '../job-type/job-type.component';

@Component({
  selector: 'app-title',
  template: `
    <fl-bit class="SpinnerContainer">
      <ng-container [ngSwitch]="jobType">
        <fl-heading
          i18n="Post Job Page form title field label"
          *ngSwitchCase="JobType.CONTEST"
          [headingType]="HeadingType.H3"
          [flMarginBottom]="Margin.XXXSMALL"
          [size]="TextSize.MID"
        >
          Choose a name for your contest
        </fl-heading>
        <fl-heading
          i18n="Post Job Page form title field label"
          *ngSwitchDefault
          [headingType]="HeadingType.H3"
          [flMarginBottom]="Margin.XXXSMALL"
          [size]="TextSize.MID"
        >
          Choose a name for your project
        </fl-heading>
      </ng-container>
      <fl-spinner
        class="SpinnerContainer-spinner"
        *ngIf="showSpinner$ | async"
        flTrackingLabel="PJPTitleAsyncRequestSpinner"
        [flMarginBottom]="Margin.XXSMALL"
        [size]="SpinnerSize.SMALL"
      ></fl-spinner>
    </fl-bit>
    <fl-input
      *ngIf="placeholder; else default"
      flTrackingLabel="TextInputField"
      [control]="control"
      [flMarginBottom]="Margin.LARGE"
      [placeholder]="placeholder"
      [size]="InputSize.LARGE"
    ></fl-input>
    <ng-template #default>
      <fl-input
        flTrackingLabel="TextInputField"
        i18n-placeholder="Post Job Page form title field placeholder"
        placeholder="e.g. Build me a website"
        [control]="control"
        [flMarginBottom]="Margin.LARGE"
        [size]="InputSize.LARGE"
      ></fl-input>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent {
  TextSize = TextSize;
  HeadingType = HeadingType;
  InputSize = InputSize;
  JobType = JobType;
  Margin = Margin;
  SpinnerSize = SpinnerSize;

  @Input() control: FormControl;
  @Input() jobType: JobType;
  @Input() placeholder?: string;
  @Input() showSpinner$: Rx.Observable<boolean>;
}
